import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";

// ✅ FETCH LIST WITH CACHE
export const fetchJointSourceList = createAsyncThunk(
  "sourceList/fetchJointSourceList",
  async ({ page = 1, search = "" }, { rejectWithValue, getState }) => {
    try {
      const { sourceList } = getState();
      const { pageSize, cache } = sourceList;

      const cacheKey = `${page}_${search}_${pageSize}`;

      // ✅ return cached data if exists
      if (cache[cacheKey]) {
        return { data: cache[cacheKey], page, search, pageSize, fromCache: true };
      }

      let url = `/account/panel/join?page=${page}&page_size=${pageSize}`;
      if (search) url += `&search=${search}`;

      const response = await api.get(url);

      return { data: response.data, page, search, pageSize, fromCache: false };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const JointSourceSlice = createSlice({
  name: "sourceList",

  initialState: {
    list: [],
    search: "",
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    status: "idle",
    error: null,
    cache: {}, // ✅ cache per page+search+size
  },

  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.currentPage = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchJointSourceList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchJointSourceList.fulfilled, (state, action) => {
        const { data, page, search, pageSize, fromCache } = action.payload;

        // ✅ update cache if not cached
        if (!fromCache) {
          const cacheKey = `${page}_${search}_${pageSize}`;
          state.cache[cacheKey] = data;
        }

        state.list = data?.result || [];
        state.currentPage = page;
        state.search = search;
        state.pageSize = pageSize;
        state.totalPages = Math.ceil((data?.pagination?.count || 0) / pageSize);
        state.status = "succeeded";
      })
      .addCase(fetchJointSourceList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setPage, setPageSize, setSearch, clearError } = JointSourceSlice.actions;
export default JointSourceSlice.reducer;